import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
//!!import Icon from "components/Icon";
import PageSection from "components/PageSection";
import ImageCard2 from "components/ImageCard2";

const Contact = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const { anchor, header, subheader, contactImageFileName } = frontmatter;

/*!!  return (
    <PageSection className={className} id={anchor}>
      <Row className="justify-content-center">
        <Col lg={8} className="text-center">
          <h2 className="mt-0">{header}</h2>
          <hr className="divider my-4" />
          <p className="text-muted mb-5">{subheader}</p>
        </Col>
      </Row>
    </PageSection>
  );
!!*/
  return (
    <PageSection className={className} id={anchor}>
      <Row className="justify-content-center">
        <Col lg={8} className="text-center">
          <ImageCard2
            imageFileName={contactImageFileName}
            header={header}
            subheader={subheader}
          />
        </Col>
      </Row>
    </PageSection>
  );
};

Contact.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Contact.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Contact;
